import React, { useState } from "react";
import {
  BarChart,
  Bar,
  Legend,
  LineChart,
  Line,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Switch, Select, Form } from "antd";
import styled from "styled-components";

const Customstyle = styled.div`
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .title-container {
    display: flex;
    align-items: center;
    position: relative;
    gap: 15px;
    white-space: nowrap;
  }

  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 19.36px;
    display: flex;
    align-items: center;
    position: relative;
    top: -8px;
  }
.value-container {
  display: flex;
  align-items: baseline; 
  gap: 4px;
  top: -8px;
}

.value {
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  display: flex;
  align-items: center;
  position: relative;
  top: -8px;
}

.unit {
  font-weight: 400;
  font-size: 14px;
  line-height: 16.94px;
  display: flex;
  align-items: center;
  position: relative;
  top: -8px;}
`;

const { Option } = Select;

const ConsignmentsMonth = [
  { letter: "Jan", frequency: 18 },
  { letter: "Feb", frequency: 20 },
  { letter: "Mar", frequency: 12 },
  { letter: "Apr", frequency: 8 },
  { letter: "May", frequency: 6 },
  { letter: "Jun", frequency: 10 },
  { letter: "Jul", frequency: 16 },
  { letter: "Aug", frequency: 20 },
  { letter: "Sep", frequency: 16 },
  { letter: "Oct", frequency: 10 },
  { letter: "Nov", frequency: 22 },
  { letter: "Dec", frequency: 20 },
];

const ConsignmentsYear = [
  { letter: "2011", frequency: 18 },
  { letter: "2012", frequency: 20 },
  { letter: "2013", frequency: 12 },
  { letter: "2014", frequency: 8 },
  { letter: "2015", frequency: 6 },
  { letter: "2016", frequency: 10 },
  { letter: "2017", frequency: 16 },
  { letter: "2018", frequency: 20 },
  { letter: "2019", frequency: 16 },
  { letter: "2020", frequency: 10 },
  { letter: "2021", frequency: 22 },
  { letter: "2022", frequency: 20 },
];

const TripsMonth = [
  { name: "Jan", Local: 4, Safari: 6 },
  { name: "Feb", Local: 10, Safari: 4 },
  { name: "Mar", Local: 14, Safari: 6 },
  { name: "Apr", Local: 10, Safari: 4 },
  { name: "May", Local: 12, Safari: 2 },
  { name: "Jun", Local: 12, Safari: 2 },
  { name: "Jul", Local: 12, Safari: 2 },
  { name: "Aug", Local: 14, Safari: 8 },
  { name: "Sep", Local: 4, Safari: 4 },
  { name: "Oct", Local: 6, Safari: 8 },
  { name: "Nov", Local: 6, Safari: 8 },
  { name: "Dec", Local: 6, Safari: 8 },
];

const TripsYear = [
  { name: "2011", Local: 4, Safari: 16 },
  { name: "2012", Local: 10, Safari: 14 },
  { name: "2013", Local: 14, Safari: 10 },
  { name: "2014", Local: 10, Safari: 14 },
  { name: "2015", Local: 12, Safari: 12 },
  { name: "2016", Local: 12, Safari: 12 },
  { name: "2017", Local: 12, Safari: 12 },
  { name: "2018", Local: 14, Safari: 10 },
  { name: "2019", Local: 4, Safari: 20 },
  { name: "2020", Local: 6, Safari: 18 },
  { name: "2021", Local: 6, Safari: 18 },
  { name: "2022", Local: 6, Safari: 18 },
];

const DistanceMonth = [
  { letter: "Jan", frequency: 10 },
  { letter: "Feb", frequency: 4 },
  { letter: "Mar", frequency: 6 },
  { letter: "Apr", frequency: 20 },
  { letter: "May", frequency: 2 },
  { letter: "Jun", frequency: 14 },
  { letter: "Jul", frequency: 12 },
  { letter: "Aug", frequency: 10 },
  { letter: "Sep", frequency: 20 },
  { letter: "Oct", frequency: 2 },
  { letter: "Nov", frequency: 8 },
  { letter: "Dec", frequency: 6 },
];

const DistanceYear = [
  { letter: "2011", frequency: 10 },
  { letter: "2012", frequency: 4 },
  { letter: "2013", frequency: 6 },
  { letter: "2014", frequency: 20 },
  { letter: "2015", frequency: 2 },
  { letter: "2016", frequency: 14 },
  { letter: "2017", frequency: 12 },
  { letter: "2018", frequency: 10 },
  { letter: "2019", frequency: 20 },
  { letter: "2020", frequency: 2 },
  { letter: "2021", frequency: 8 },
  { letter: "2022", frequency: 6 },
];

const FuelMonth = [
  { letter: "Jan", frequency: 10 },
  { letter: "Feb", frequency: 20 },
  { letter: "Mar", frequency: 12 },
  { letter: "Apr", frequency: 8 },
  { letter: "May", frequency: 6 },
  { letter: "Jun", frequency: 10 },
  { letter: "Jul", frequency: 14 },
  { letter: "Aug", frequency: 18 },
  { letter: "Sep", frequency: 12 },
  { letter: "Oct", frequency: 6 },
  { letter: "Nov", frequency: 2 },
  { letter: "Dec", frequency: 20 },
];

const FuelYear = [
  { letter: "2011", frequency: 4 },
  { letter: "2012", frequency: 2 },
  { letter: "2013", frequency: 12 },
  { letter: "2014", frequency: 8 },
  { letter: "2015", frequency: 6 },
  { letter: "2016", frequency: 20 },
  { letter: "2017", frequency: 10 },
  { letter: "2018", frequency: 2 },
  { letter: "2019", frequency: 6 },
  { letter: "2020", frequency: 20 },
  { letter: "2021", frequency: 8 },
  { letter: "2022", frequency: 20 },
];

const DeliveryMonth = [
  { letter: "Jan", frequency: 10 },
  { letter: "Feb", frequency: 4 },
  { letter: "Mar", frequency: 6 },
  { letter: "Apr", frequency: 20 },
  { letter: "May", frequency: 2 },
  { letter: "Jun", frequency: 14 },
  { letter: "Jul", frequency: 12 },
  { letter: "Aug", frequency: 10 },
  { letter: "Sep", frequency: 20 },
  { letter: "Oct", frequency: 2 },
  { letter: "Nov", frequency: 8 },
  { letter: "Dec", frequency: 6 },
];

const DeliveryYear = [
  { letter: "2011", frequency: 10 },
  { letter: "2012", frequency: 4 },
  { letter: "2013", frequency: 6 },
  { letter: "2014", frequency: 20 },
  { letter: "2015", frequency: 2 },
  { letter: "2016", frequency: 14 },
  { letter: "2017", frequency: 12 },
  { letter: "2018", frequency: 10 },
  { letter: "2019", frequency: 20 },
  { letter: "2020", frequency: 2 },
  { letter: "2021", frequency: 8 },
  { letter: "2022", frequency: 6 },
];

const CarbonfootprintsMonth = [
  { letter: "Jan", frequency: 1000 },
  { letter: "Feb", frequency: 4000 },
  { letter: "Mar", frequency: 650 },
  { letter: "Apr", frequency: 2000 },
  { letter: "May", frequency: 2500 },
  { letter: "Jun", frequency: 1400 },
  { letter: "Jul", frequency: 1200 },
  { letter: "Aug", frequency: 1000 },
  { letter: "Sep", frequency: 2050 },
  { letter: "Oct", frequency: 2100 },
  { letter: "Nov", frequency: 800 },
  { letter: "Dec", frequency: 600 },
];

const CarbonfootprintsYear = [
  { letter: "2011", frequency: 2000 },
  { letter: "2012", frequency: 3000 },
  { letter: "2013", frequency: 1000 },
  { letter: "2014", frequency: 3000 },
  { letter: "2015", frequency: 2500 },
  { letter: "2016", frequency: 1400 },
  { letter: "2017", frequency: 1200 },
  { letter: "2018", frequency: 1000 },
  { letter: "2019", frequency: 2000 },
  { letter: "2020", frequency: 2300 },
  { letter: "2021", frequency: 850 },
  { letter: "2022", frequency: 690 },
];

const ReturnsMonth = [
  { letter: "Jan", frequency: 10 },
  { letter: "Feb", frequency: 20 },
  { letter: "Mar", frequency: 30 },
  { letter: "Apr", frequency: 80 },
  { letter: "May", frequency: 60 },
  { letter: "Jun", frequency: 10 },
  { letter: "Jul", frequency: 40 },
  { letter: "Aug", frequency: 80 },
  { letter: "Sep", frequency: 100 },
  { letter: "Oct", frequency: 50 },
  { letter: "Nov", frequency: 20 },
  { letter: "Dec", frequency: 90 },
];

const ReturnsYear = [
  { letter: "2011", frequency: 10 },
  { letter: "2012", frequency: 20 },
  { letter: "2013", frequency: 30 },
  { letter: "2014", frequency: 80 },
  { letter: "2015", frequency: 60 },
  { letter: "2016", frequency: 10 },
  { letter: "2017", frequency: 40 },
  { letter: "2018", frequency: 80 },
  { letter: "2019", frequency: 100 },
  { letter: "2020", frequency: 50 },
  { letter: "2021", frequency: 20 },
  { letter: "2022", frequency: 90 },
];

const MileageMonth = [
  { letter: "Jan", frequency: 10 },
  { letter: "Feb", frequency: 4 },
  { letter: "Mar", frequency: 6 },
  { letter: "Apr", frequency: 20 },
  { letter: "May", frequency: 2 },
  { letter: "Jun", frequency: 14 },
  { letter: "Jul", frequency: 12 },
  { letter: "Aug", frequency: 10 },
  { letter: "Sep", frequency: 20 },
  { letter: "Oct", frequency: 2 },
  { letter: "Nov", frequency: 8 },
  { letter: "Dec", frequency: 6 },
];

const MileageYear = [
  { letter: "2011", frequency: 10 },
  { letter: "2012", frequency: 4 },
  { letter: "2013", frequency: 6 },
  { letter: "2014", frequency: 20 },
  { letter: "2015", frequency: 2 },
  { letter: "2016", frequency: 14 },
  { letter: "2017", frequency: 12 },
  { letter: "2018", frequency: 10 },
  { letter: "2019", frequency: 20 },
  { letter: "2020", frequency: 2 },
  { letter: "2021", frequency: 8 },
  { letter: "2022", frequency: 6 },
];

const chartTitles = [
  "Total No. of Consignments",
  "Total No. of Trips",
  "Total Distance Traveled",
  "Total Fuel Consumption",
  "Average Delivery Rate",
  "Total Carbon Footprint",
  "Total Returns",
  "Average Mileage Per Year",
];

const chartValues = ["67", "180", "345", "250", "72%", "87890", "16", "60"];

const chartUnits = ["", "", "Kms", "L", "", "KgCO2", "", "Km/L"];

const ChartGrid = () => {
  const [isYearly, setIsYearly] = useState(false);
  const chartData = isYearly
    ? [
        ConsignmentsMonth,
        TripsMonth,
        DistanceMonth,
        FuelMonth,
        DeliveryMonth,
        CarbonfootprintsMonth,
        ReturnsMonth,
        MileageMonth,
      ]
    : [
        ConsignmentsYear,
        TripsYear,
        DistanceYear,
        FuelYear,
        DeliveryYear,
        CarbonfootprintsYear,
        ReturnsYear,
        MileageYear,
      ];

  return (
    <Customstyle>
      <div style={{ padding: "16px" }}>
        <div
          style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              background: "#FFFFFF",
              padding: "9px 16px",
              borderRadius: "26px",
              width: "200px",
            }}
          >
            <span
              style={{
                fontWeight: "500",
                color: !isYearly ? "#595959" : "#2C963D",
                backgroundColor: isYearly ? "#E8FFEC" : "#FFFFFF",
              }}
            >
              Monthly
            </span>

            <Switch
              checked={!isYearly}
              onChange={() => setIsYearly(!isYearly)}
              sx={{
                "& .MuiSwitch-thumb": { backgroundColor: "#2C963D" },
                "& .MuiSwitch-track": { backgroundColor: "#2C963D" },
              }}
            />

            <span
              style={{
                fontWeight: "500",
                color: isYearly ? "#595959" : "#2C963D",
                backgroundColor: isYearly ? "#FFFFFF" : "#E8FFEC",
              }}
            >
              Yearly
            </span>
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "24px",
            padding: "16px",
          }}
        >
          {chartTitles.map((title, index) => (
            <div
              key={index}
              style={{
                width: "563px",
                height: "480px",
                background: "white",
                padding: "16px",
                borderRadius: "12px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              <div className="head">
                <div className="title-container">
                  <span className="title">{chartTitles[index]}</span>
                  <span className="value-container">
                    <span className="value">{chartValues[index]}</span>
                    <span className="unit">{chartUnits[index]}</span>
                  </span>
                </div>
                <div className="dropstyle">
                  <Form.Item
                    label=""
                    name="dropdown"
                    rules={[
                      { required: true, message: "Please select an option!" },
                    ]}
                  >
                    {isYearly && (
                      <Select
                        placeholder="2024"
                        style={{
                          width: "184px",
                          height: "32px", // Ensure it's aligned with title height
                          borderRadius: "20px",
                          borderWidth: "1px",
                          color: "#363636",
                        }}
                      >
                        <Option value="option1">2011</Option>
                        <Option value="option2">2012</Option>
                        <Option value="option3">2013</Option>
                        <Option value="option4">2014</Option>
                      </Select>
                    )}
                  </Form.Item>
                </div>
              </div>

              <ResponsiveContainer width="100%" height={400}>
                {index === 0 ? (
                  <BarChart
                    data={chartData[index]}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <XAxis
                      dataKey="letter"
                      axisLine={false}
                      tickLine={false}
                      interval={0}
                      tick={{
                        textAnchor: "start", // Center align text
                        fontSize: 11,
                      }}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      interval={0}
                      domain={[0, 24]}
                      tickCount={13}
                    />
                    <Tooltip />
                    <Bar
                      dataKey="frequency"
                      stackId="a"
                      fill="#62A1FF"
                      barSize={20}
                      radius={5}
                    />
                  </BarChart>
                ) : index === 1 ? (
                  <BarChart
                    data={chartData[index]}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <XAxis
                      dataKey="name"
                      axisLine={false}
                      tickLine={false}
                      interval={0}
                      tick={{
                        textAnchor: "start",
                        fontSize: 11,
                      }}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      interval={0}
                      domain={[0, 24]}
                      tickCount={13}
                    />
                    <Tooltip />
                    <Legend
                      layout="horizontal"
                      verticalAlign="top"
                      align="right"
                    />
                    <Bar
                      dataKey="Local"
                      stackId="a"
                      fill="#8577F1"
                      barSize={20}
                      radius={5}
                    />
                    <Bar
                      dataKey="Safari"
                      stackId="a"
                      fill="#83F1A2"
                      barSize={20}
                      radius={5}
                    />
                  </BarChart>
                ) : index === 2 ? (
                  <AreaChart
                    data={chartData[index]}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <defs>
                      <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                        <stop
                          offset="5%"
                          stopColor="rgba(32, 221, 175, 1)"
                          stopOpacity={0.8}
                        />
                        <stop
                          offset="95%"
                          stopColor="rgba(217, 217, 217, 0)"
                          stopOpacity={0.8}
                        />
                      </linearGradient>
                    </defs>
                    {/* <CartesianGrid strokeDasharray="3 3" /> */}
                    <XAxis
                      dataKey="letter"
                      tickLine={false}
                      axisLine={false}
                      interval={0}
                      tick={{
                        textAnchor: "start", // Center align text
                        fontSize: 11,
                      }}
                    />
                    <YAxis
                      tickLine={false}
                      axisLine={false}
                      interval={0}
                      domain={[0, 20]}
                      tickCount={11}
                    />
                    <Tooltip />
                    <Area
                      type="monotone"
                      dataKey="frequency"
                      stroke="rgba(32, 221, 175, 1)"
                      fill="url(#colorUv)"
                    />
                  </AreaChart>
                ) : index === 3 ? (
                  <AreaChart
                    data={chartData[index]}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <defs>
                      <linearGradient id="colorUv1" x1="0" y1="0" x2="0" y2="1">
                        <stop
                          offset="5%"
                          stopColor="rgba(228, 164, 0, 1)"
                          stopOpacity={0.8}
                        />
                        <stop
                          offset="95%"
                          stopColor="rgba(217, 217, 217, 0)"
                          stopOpacity={0.8}
                        />
                      </linearGradient>
                    </defs>
                    <XAxis
                      dataKey="letter"
                      tickLine={false}
                      axisLine={false}
                      interval={0}
                      tick={{
                        textAnchor: "start",
                        fontSize: 11,
                      }}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      interval={0}
                      domain={[0, 20]}
                      tickCount={11}
                    />
                    <Tooltip />
                    <Area
                      type="monotone"
                      dataKey="frequency"
                      stroke="rgba(228, 164, 0, 1)"
                      fill="url(#colorUv1)"
                    />
                  </AreaChart>
                ) : index === 4 ? (
                  <LineChart
                    width={500}
                    height={300}
                    data={chartData[index]}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <XAxis
                      dataKey="letter"
                      tickLine={false}
                      axisLine={false}
                      interval={0}
                      tick={{
                        textAnchor: "start",
                        fontSize: 11,
                      }}
                    />
                    <YAxis
                      tickLine={false}
                      axisLine={false}
                      interval={0}
                      domain={[0, 100]}
                      tickCount={11}
                    />
                    <Tooltip />
                    <Line
                      type="linear"
                      dataKey="frequency"
                      stroke="rgba(177, 32, 221, 1)"
                      strokeWidth={1}
                      dot={{
                        r: 6,
                        fill: "rgba(177, 32, 221, 1)",
                        strokeWidth: 2,
                      }}
                    />
                  </LineChart>
                ) : index === 5 ? (
                  <AreaChart
                    data={chartData[index]}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    {/* <CartesianGrid strokeDasharray="3 3" /> */}
                    <XAxis
                      dataKey="letter"
                      tickLine={false}
                      axisLine={false}
                      tick={{
                        textAnchor: "start", // Center align text
                        fontSize: 11,
                      }}
                    />
                    <YAxis
                      tickLine={false}
                      axisLine={false}
                      domain={[0, 4000]}
                      tickCount={11}
                    />
                    <Tooltip />
                    <Area
                      type="linear"
                      dataKey="frequency"
                      stroke="rgba(95, 230, 118, 1)"
                      fill="rgba(95, 230, 118, 1)"
                    />
                  </AreaChart>
                ) : index === 6 ? (
                  <BarChart
                    data={chartData[index]}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <XAxis
                      dataKey="letter"
                      tickLine={false}
                      axisLine={false}
                      interval={0}
                      tick={{
                        textAnchor: "start", // Center align text
                        fontSize: 11,
                      }}
                    />
                    <YAxis
                      domain={[0, 100]}
                      tickCount={11}
                      tickLine={false}
                      axisLine={false}
                      interval={0}
                    />
                    <Tooltip />
                    <Bar
                      dataKey="frequency"
                      stackId="a"
                      fill="#FF9C9C"
                      barSize={20}
                      radius={5}
                    />
                  </BarChart>
                ) : (
                  <LineChart
                    width={500}
                    height={300}
                    data={chartData[index]}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    {/* <CartesianGrid strokeDasharray="3 3" /> */}
                    <XAxis
                      dataKey="letter"
                      tickLine={false}
                      axisLine={false}
                      interval={0}
                      tick={{
                        textAnchor: "start", // Center align text
                        fontSize: 11,
                      }}
                    />
                    <YAxis
                      domain={[0, 100]}
                      tickCount={11}
                      interval={0}
                      tickLine={false}
                      axisLine={false}
                    />
                    <Tooltip />
                    <Line
                      type="linear"
                      dataKey="frequency"
                      stroke="rgba(32, 161, 221, 1)"
                      strokeWidth={1}
                      dot={{
                        r: 6,
                        fill: "rgba(32, 161, 221, 1)",
                        strokeWidth: 2,
                      }}
                    />
                  </LineChart>
                )}
              </ResponsiveContainer>
            </div>
          ))}
        </div>
      </div>
    </Customstyle>
  );
};

export default ChartGrid;
